<script>
  import { fade } from "svelte/transition";
  import { slide } from "../data/slideInvert";

  export let cost;
  export let benefit;
  export let Y;
</script>

<style lang="scss">
  .bar {
    height: 10px;

    &--cost {
      background-color: lightcoral;
    }

    &--benefit {
      background-color: lightblue;
    }
  }
</style>

<div class="bar-container">
  {#if cost && benefit}
    <div
      class="bar bar--benefit"
      style="width: {Y(benefit)}%;"
      in:slide={{ duration: 200, delay: 300 }}
      out:slide={{ duration: 200 }} />
    <div
      class="bar bar--cost"
      style="width: {Y(cost)}%;"
      in:slide={{ duration: 200, delay: 300 }}
      out:slide={{ duration: 200 }} />
  {:else}
    <span>ไม่มีข้อมูล</span>
  {/if}

</div>
